export default "__VITE_ASSET__BAbgkLHZ__"